import { withProviderErrorBoundary } from '@edreamsodigeo/frontend-core';

import withCheckoutContext from '@/withCheckoutContext';
import PricesLoadTimeMetricIntegrationProvider from '@/clientState/providers/PricesLoadTimeMetricIntegrationProvider';

export default withCheckoutContext(
  withProviderErrorBoundary(PricesLoadTimeMetricIntegrationProvider, {
    name: 'PricesLoadTimeMetricIntegrationProvider',
  })
);
